var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 16a2.006 2.006 0 002 2h8a2.006 2.006 0 002-2V4H1zM14 1h-3.5l-1-1h-5l-1 1H0v2h14z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE0IDE4Ij4KICAgIDxwYXRoCiAgICAgICAgICAgIGQ9Ik02LDE5YTIuMDA2LDIuMDA2LDAsMCwwLDIsMmg4YTIuMDA2LDIuMDA2LDAsMCwwLDItMlY3SDZaTTE5LDRIMTUuNWwtMS0xaC01bC0xLDFINVY2SDE5WiIKICAgICAgICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTUgLTMpIgogICAgICAgICAgICBmaWxsPSJjdXJyZW50Q29sb3IiCiAgICAvPgo8L3N2Zz4=";
export { SvgTrash as ReactComponent };